import update from 'immutability-helper';
import {
  DESTROY,
  SET_SELECTED_TICKETS_MATCH_TICKETS,
  SET_JUSTIFICATION_MATCH_TICKETS,
  CANCEL_REQUEST_MATCH_TICKETS,
  UPDATE_TICKET_MATCH_TICKETS,
} from './action_types';
import { MatchTicketsSelectedTicketsreducer } from './Types/match_tickets_selected_tickets_reducer.types';

const initialState: MatchTicketsSelectedTicketsreducer = {
  tickets: [],
  justification: {},
};

const matchTicketsSelectedTicketsReducer = (state = initialState, action: any) => {
  if (action.type === DESTROY) {
    return initialState;
  }

  if (action.type === SET_SELECTED_TICKETS_MATCH_TICKETS) {
    return update(state, {
      tickets: { $set: action.payload },
    });
  }

  if (action.type === SET_JUSTIFICATION_MATCH_TICKETS) {
    return update(state, {
      justification: { $set: action.payload },
    });
  }

  if (action.type === UPDATE_TICKET_MATCH_TICKETS) {
    // not correct syntax, check
    let newArr = state.tickets.map((ticket: any) =>
      ticket.id !== action.payload.ticket.id
        ? ticket
        : update(ticket, { $set: action.payload.ticket }),
    );

    return update(state, {
      tickets: { $set: newArr },
    });
  }

  if (action.type === CANCEL_REQUEST_MATCH_TICKETS) {
    let oldArr = [...state.tickets];

    let newArr = oldArr.filter(item => item !== action.payload);

    return update(state, {
      tickets: { $set: newArr },
    });
  }

  return state;
};

export default matchTicketsSelectedTicketsReducer;
